import { DynamoSystemApi } from '../../../services'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'

export const useAdminLoaders = () => {
    const loaders = useLoaders()

    return () => {
        const loadAdmin = (id: string) => {
            const { load } = loaders(undefined, DynamoSystemApi)
            return load(TableName.ADMIN, id)
        }

        return {
            loadAdmin
        }
    }
}
